<template>
    <div>
        <div :class="['code-input', { 'small-length': length <= 3 }]">
            <input
            ref="inputs"
            v-for="(digit, index) in code"
            :key="index"
            type="text"
            maxlength="1"
            v-model="code[index]"
            @input="onInput(index)"
            @keydown.backspace="onBackspace(index)"
            @keydown="onKeyDown($event, index)"
            :class="['digit-input', { 'error': hasError, 'success': success }]"
            :aria-label="'Digit ' + (index + 1)"
            :disabled="isDisabled"
            placeholder="0"
            />
        </div>
        <div v-if="hasError" class="error-message">
            <p>{{ erroMessage }}</p>
        </div>
        <div v-if="success" class="success-message">
            <p>
                <span class="fa fa-spinner fa-spin" />
                {{ $t('You will be redirected in a few seconds') }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        length: {
            type: Number,
            default: 6
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        length(newLength) {
            this.code = Array(newLength).fill('');
        },
        disabled(newDisabled) {
            this.isDisabled = newDisabled;
        }
    },
    data() {
        return {
            code: Array(this.length).fill(''),
            hasError: false,
            erroMessage: '',
            success: false,
            isDisabled: this.disabled
        };
    },
    mounted() {
        this.$refs.inputs[0].focus();
    },
    methods: {
        onInput(index) {
            if (this.code[index].length === 1 && index < this.code.length - 1) {
                this.$refs.inputs[index + 1].focus();
            }
            this.$emit('input', this.code.join(''));
        },
        onBackspace(index) {
            if (this.code[index] === '' && index > 0) {
                this.$refs.inputs[index - 1].focus();
            }
        },
        onKeyDown(event, index) {
            const key = event.key;
            if (!/^[0-9]$/.test(key) && key !== 'Backspace' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
                event.preventDefault();
            }
        },
        reset() {
            this.code = Array(this.length).fill('');
            this.$refs.inputs[0].focus();
        },
        setError(erroMessage) {
            this.hasError = true;
            this.isDisabled = true;
            this.erroMessage = erroMessage;
            setTimeout(() => {
                this.isDisabled = false;
            }, 1000);
        },
        setSuccess(success = true) {
            this.success = success;
            this.message = 'Redirecting...';
        },
        clearError() {
            this.hasError = false;
            this.erroMessage = '';
        }
    }
};
</script>

<style scoped>
.code-input {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 300px;
    margin: 8px auto;
}

.code-input.small-length .digit-input {
    margin-right: 10px;
}

.digit-input {
    width: 40px;
    height: 50px;
    text-align: center;
    font-size: 24px;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 8px;
    gap: 8px;
}

.digit-input.error {
    background-color: #ffe6e6;
    border-color: red;
}

.error-message {
    color: red;
    font-size: 14px;
    margin-top: 8px;
    text-align: center;
}

.digit-input.success {
    background-color: #e6ffea;
    border-color: green;
}

.success-message {
    color: green;
    font-size: 14px;
    margin-top: 8px;
    text-align: center;
}
</style>